import React, { useEffect, useRef, useState } from 'react';
import c from 'classnames';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import Cookies from 'js-cookie';

import {
  Container,
  NavigationScroll,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  LanguageSwitchWrapper,
  Hamburger,
} from '../../components';

import MainMenu from '../Menu/MainMenu';
import SecondaryMenu from '../Menu/SecondaryMenu';
import HighlightedMenu from '../Menu/HighlightedMenu';

import './style.scss';

const Header = React.memo(({ crisisBannerTimeStamp, forwardRef, crisisBannerHeight }) => {
  const { t } = useTranslation();
  const searchRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);
  const [inputValue, setInputValue] = useState(null);
  const history = useHistory();
  const lang = useSelector((state) => state.getIn(['ui', 'language']));

  const bannerCloseTimeStamp = Cookies.get('bannerCloseTimeStamp');

  const hamburgerMenuClasses = c('Header__hamburger__menu', {
    'Header__hamburger__menu--open': menuOpen,
  });

  const crisisBannerClasses = c('Header__hamburger__menu__container__row', 'row', {
    'crisisBannerOffset': crisisBannerTimeStamp && crisisBannerTimeStamp !== bannerCloseTimeStamp,
  });

  const toggleMenu = () => {
    if (!menuOpen) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
    setMenuOpen(!menuOpen);
  };

  const submitSearch = () => {
    history.push({
      pathname: '/search',
      search: `?q=${inputValue || ''}`,
    });
    setSearchVisible(false);
  };
  const catchEnterEscape = (e) => {
    if (e.key === 'Enter') {
      submitSearch();
    }
    if (e.key === 'Escape') {
      setSearchVisible(false);
    }
  };

  const closeMenu = () => {
    document.body.classList.remove('overflow-hidden');
    setMenuOpen(false);
  };
  const hideMenu = () => {
    closeMenu();
  };

  useEffect(() => {
    if (searchRef.current && searchVisible) {
      searchRef.current.focus();
    }
  }, [searchRef, searchVisible]);

  return (
    <>
      <NavigationScroll>
        <header className="Header" ref={forwardRef}>
          <div className="Header__inner">
            <div className="Header__logo">
              <CoreLink
                to={`/${lang}/`}
              >
                <div className="Header__logo__text" />
              </CoreLink>
            </div>
            <div className="Header__menu">
              <MainMenu />
            </div>
            <div className="Header__links">
              <HighlightedMenu onItemClick={hideMenu} />
              <div>
                <Button
                  className="Header__links__search"
                  onClick={() => { setSearchVisible(true); setMenuOpen(false); }}
                >
                  <div className="icon-after icon-search" />
                </Button>
              </div>
              <div className="Hamburger__wrapper">
                <Hamburger key="hamburger123" onClick={toggleMenu} menuOpen={menuOpen} />
              </div>
            </div>
          </div>
          <div className={hamburgerMenuClasses} style={{ marginTop: crisisBannerHeight }}>
            <Container className="Header__hamburger__menu__container">
              <div className={crisisBannerClasses}>
                <div className="col-12 col-md-6 col-lg-7 offset-lg-1">
                  <HighlightedMenu onItemClick={hideMenu} />
                </div>
                <div className="col-12 col-md-6 col-lg-7 offset-lg-1">
                  <div className="Header__hamburger__menu__main__menu">
                    <MainMenu onItemClick={hideMenu} />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="Header__hamburger__menu__secondary__menu">
                    <SecondaryMenu onItemClick={hideMenu} />
                    <LanguageSwitchWrapper onClick={closeMenu} />
                  </div>
                </div>
              </div>
            </Container>
            <div className="Header__hamburger__menu__quote">
              {/* Make me translatable */}
              <div className="Header__hamburger__menu__quote__text">
                Nederland Circulair, elke verpakking telt
              </div>
            </div>
          </div>
          <div className={`Header__search_input ${searchVisible ? 'visible' : ''}`}>
            <span
              className="Header__search_input__icon_search icon icon-search"
            />
            <input
              onChange={(e) => { setInputValue(e.target.value); }}
              onKeyDown={(e) => { catchEnterEscape(e); }}
              type="text"
              name="search"
              id="search"
              className="Header__links__search_input__search_input"
              placeholder={t('filters.search.query.placeholder')}
              ref={searchRef}
            />
            <span
              className="Header__search_input__icon_close icon icon-cross"
              onClick={() => { setSearchVisible(false); }}
            />
          </div>
        </header>
      </NavigationScroll>
      <div className={`Search_overlay ${searchVisible ? 'visible' : ''}`} />
    </>
  );
});

export default Header;
